module.exports = __webpack_public_path__ + "static/media/after-effects.9bfffb08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FreelancerChooser/after-effects.svg
// module id = 2075
// module chunks = 0